export const MISCELLANEOUS_ROUTES = ['/consentimento', '/contratos'] as const
